module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./FriendrankingView.js"));
	}, "FriendrankingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FriendrankingView!./src/pages/PunchClock/Friendranking/FriendrankingView.js
// module id = 2250
// module chunks = 367